module.exports = __webpack_public_path__ + "img/20.16d59d64.jpg";